import { PlaceholderPage } from './PlaceholderPage';

export const CostCentrePage = () => <PlaceholderPage title="Cost Centre" />;
